(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-offer')) {
    customElements.define('bundle-offer', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.quantityInput = this.form?.querySelector('input[name="quantity"]');
        this.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"]')) this.syncQuantity();
        });
        this.form?.addEventListener('submit', () => this.syncQuantity(), true);
        this.form?.addEventListener('formdata', (event) => {
          const selected = this.querySelector('input[type="radio"]:checked');
          if (selected) event.formData.set('quantity', selected.value);
        });
        this.syncQuantity();
      }

      syncQuantity() {
        const selected = this.querySelector('input[type="radio"]:checked');
        if (!selected || !this.quantityInput) return;

        const minimum = Number(this.quantityInput.min) || 1;
        const maximum = Number(this.quantityInput.max) || Infinity;
        this.quantityInput.value = Math.min(Math.max(Number(selected.value), minimum), maximum);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
